// eslint-disable-next-line no-unused-vars
import { Breadcrumb, Button, Col, Row, Typography } from "antd";
import { useEffect, useState } from "react";
// eslint-disable-next-line no-unused-vars
import { Link, useParams } from "react-router-dom";
// eslint-disable-next-line no-unused-vars
import NewNote from "../../../components/Modals/NewNote";
// eslint-disable-next-line no-unused-vars
import ProfessionalNotesTable from "../../../components/Tables/ProfessionalNotesTable";
import { translate } from "../../../locale";
import UserServices from "../../../services/UserServices";
// eslint-disable-next-line no-unused-vars
const { Title } = Typography;

const ProfessionalNotes = () => {
  const [modalVisible, setModalVisible] = useState(false);
  const [reloadTable, setReloadTable] = useState(null);
  const [patient, setPatient] = useState(null);
  const { username } = useParams();

  useEffect(() => {
    const fetchPatient = async () => {
      try {
        const res = await UserServices.getProfile(username);
        if (res.status >= 200 && res.status < 300) {
          setPatient(res.data.my_contact_info);
        }
      } catch (err) {
        console.error(err);
      }
    };
    fetchPatient();
  }, [username]);

  const handleModalCancel = () => {
    setModalVisible(false);
  };

  const handleModalComplete = () => {
    setModalVisible(false);
    setReloadTable((v) => v + 1);
  };

  const handleSendInvittion = () => {
    setModalVisible(true);
  };

  return (
    <div className="flex flex-col min-h-full w-screen max-w-7xl pb-16 m-10">
      <Row>
        <Col className="gutter-row" span="24">
          <Breadcrumb>
            <Breadcrumb.Item>
              <Link to="/admin">{translate("Inicio")}</Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              <Link to={`/admin/buscar-paciente/${username}`}>
                {translate("Resumen individual")}
              </Link>
            </Breadcrumb.Item>
            <Breadcrumb.Item>
              {translate("Notas del profesional")}
            </Breadcrumb.Item>
            {patient && (
              <Breadcrumb.Item>
                {patient.first_name} {patient.last_name} - {username}
              </Breadcrumb.Item>
            )}
          </Breadcrumb>
        </Col>
        <Col span="24" className="my-4">
          <Title level={2} className="text-center">
            {translate("Notas del profesional")}
          </Title>
        </Col>

        <Col className="gutter-row" span="12">
          <div className="text-start">
            <Button
              type="primary"
              className="bg-custom_primary border-custom_primary"
              onClick={handleSendInvittion}
            >
              {translate("Nueva nota")}
            </Button>
            <NewNote
              username={username}
              visible={modalVisible}
              onCancel={handleModalCancel}
              onComplete={handleModalComplete}
            />
          </div>
        </Col>

        <Col span="24" className="mt-6">
          <ProfessionalNotesTable reload={reloadTable} />
        </Col>
      </Row>
    </div>
  );
};

export default ProfessionalNotes;
